/* src/app/dialogs/activation-article-editor/activation-article-editor.component.css */
/*# sourceMappingURL=activation-article-editor.component-FDEN7MAJ.css.map */
